<div class="flex flex-col justify-between h-full">
  <!-- Form Content -->
  <div class="p-6" [formGroup]="form">
    <div class="flex flex-col gap-4">
      <app-form-card title="Load Details" icon="Package">
        <div
          class="grid grid-cols-1 gap-x-6 lg:gap-x-12 gap-y-4 sm:grid-cols-2"
        >
          <!-- Row 1 -->
          <app-form-field label="Commodity">
            <app-input
              formControlName="commodity"
              placeholder="e.g., General Freight"
            ></app-input>
          </app-form-field>

          <app-form-field label="Total Weight (lbs)">
            <app-number-input
              formControlName="weight"
              placeholder="e.g., 44500"
              [showGrouping]="true"
              suffixText="lbs"
            ></app-number-input>
          </app-form-field>

          <!-- Row 2 -->
          <app-form-field label="Required Equipment Type">
            <app-select
              formControlName="trailerType"
              [options]="equipmentOptions"
              placeholder="Select trailer type"
            ></app-select>
          </app-form-field>

          <!-- Conditional Reefer Fields -->
          <div class="flex items-end gap-4 animate-fade-in">
            <app-form-field label="Temp (°F)" class="flex-grow">
              <app-number-input
                formControlName="temperature"
                placeholder="e.g., 34"
                suffixText="°F"
              ></app-number-input>
            </app-form-field>
            <app-checkbox
              formControlName="isContinuous"
              label="Continuous"
            ></app-checkbox>
          </div>
          <app-form-field label="Required Endorsements" class="sm:col-span-2">
            <app-select-chip
              formControlName="endorsements"
              [options]="endorsementOptions"
              [multiple]="true"
            ></app-select-chip>
          </app-form-field>
        </div>
      </app-form-card>

      <!-- Tracking -->
      <app-form-card title="Tracking" icon="Radar">
        <div class="flex items-end gap-4 animate-fade-in">
          <app-form-field label="Tracking App" class="flex-grow">
            <app-select
              formControlName="trackingApp"
              [options]="trackingAppOptions"
              placeholder="Select tracking app"
            ></app-select>
          </app-form-field>
          <app-checkbox
            formControlName="isTracked"
            label="Is tracking required?"
          ></app-checkbox>
        </div>
      </app-form-card>

      <!-- Reference Numbers & Item Counts -->
      <app-form-card title="Reference & Counts" icon="hash">
        <div
          class="grid grid-cols-1 md:grid-cols-2 gap-x-6 lg:gap-x-12 gap-y-4"
        >
          <app-form-field label="Load-Level Reference Numbers">
            <app-key-value-array-input
              formControlName="referenceNumbers"
              addButtonLabel="Add Reference"
              [keys]="referenceTypes"
            ></app-key-value-array-input>
          </app-form-field>

          <app-form-field label="Load-Level Item Counts">
            <app-key-value-array-input
              formControlName="itemCounts"
              addButtonLabel="Add Item Count"
              [keys]="itemTypes"
            ></app-key-value-array-input>
          </app-form-field>
        </div>
      </app-form-card>
    </div>
  </div>
  <!-- Modal Actions -->
  <div
    class="flex flex-col-reverse lg:flex-row justify-end gap-3 p-2 md:p-4 border-t border-border"
  >
    <app-button variant="secondary" (click)="cancel()" [disabled]="isSaving()">
      Cancel
    </app-button>
    <app-button
      (click)="save()"
      [disabled]="form.invalid || isSaving()"
      [loading]="isSaving()"
    >
      {{ isSaving() ? "Saving..." : "Save Changes" }}
    </app-button>
  </div>
</div>
